// Module
var code = `<div class="mln-mainbody flex-col">

    <div id="dimmer" class="dimmer"></div>

    <div class="" id="preloader" style="width:40px;height:40px;display:none;position:fixed;z-index:2000">
        <div class="wBall" id="wBall_1">
            <div class="wInnerBall">
            </div>
        </div>
        <div class="wBall" id="wBall_2">
            <div class="wInnerBall">
            </div>
        </div>
        <div class="wBall" id="wBall_3">
            <div class="wInnerBall">
            </div>
        </div>
        <div class="wBall" id="wBall_4">
            <div class="wInnerBall">
            </div>
        </div>
        <div class="wBall" id="wBall_5">
            <div class="wInnerBall">
            </div>
        </div>
    </div>

    <div class="sidebar flex-col" id="sidebar">
        <div class="sidebar_header flex-row flex-no-shrink">
            <button id="sidebar-close">
                <i class="fa fa-arrow-left"></i>
            </button>
            <div class="flex-item flex-col">
                <input id="sidebar-search" type="search" placeholder="buscar" class="search-box" autocomplete="off">
            </div>
        </div>
        <div class="mln-module-menu" id="header-left" role="navigation">
            <ul class="mln-app-tab flex-col" style="margin:0"></ul>
        </div>
        <div class="flex-row">
            <div class="flex-col menu-side-panel"></div>
            <div style="overflow:auto" class="menu-tree-area lightscroll flex-item">

            </div>
        </div>
        <div class="version" style="display: flex;flex-direction: row;">
            <div>Versão PDV:</div>
            <div class="versionOmnichannel"></div>
            <div style="width:10px"></div>
            <div>Versão ERP:</div>
            <div class="versionMillennium"></div>
        </div>
    </div>

    <!-- Fixed navbar -->
    <div class="mln-module-header shadow-around-sml flex-row flex-align-center" id="header" role="navigation">
        <!-- Logo Button -->
        <button class="navbar-brand flex-row flex-align-center" title="Menu de módulos" id="menu-btn">
            <!-- <i style="min-width:1em" class="fa fa-bars"></i>-->
            <!-- Logo -->
            <svg xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:cc="http://creativecommons.org/ns#" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" sodipodi:docname="linx_logo.svg" inkscape:version="1.0 (4035a4fb49, 2020-05-01)" id="svg1034" version="1.1" viewBox="0 0 13.229167 13.229167" height="30" width="30">
                <defs id="defs1028"/>
                <sodipodi:namedview inkscape:window-maximized="0" inkscape:window-y="64" inkscape:window-x="142" inkscape:window-height="1208" inkscape:window-width="1749" units="px" showgrid="false" inkscape:document-rotation="0" inkscape:current-layer="g1087" inkscape:document-units="px" inkscape:cy="74.099026" inkscape:cx="-61.008877" inkscape:zoom="1.979899" inkscape:pageshadow="2" inkscape:pageopacity="0.0" borderopacity="1.0" bordercolor="#666666" pagecolor="#ffffff" id="base"/>
                <metadata id="metadata1031">
                    <rdf:RDF>
                        <cc:Work rdf:about="">
                            <dc:format>image/svg+xml</dc:format>
                            <dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage"/>
                            <dc:title></dc:title>
                        </cc:Work>
                    </rdf:RDF>
                </metadata>
                <g id="layer1" inkscape:groupmode="layer" inkscape:label="Layer 1">
                    <g transform="translate(33.604045,43.183516)" id="g1087">
                        <path style="fill:#ff6600;stroke:none;stroke-width:0.264583px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" d="m -23.436196,-41.794272 -7.53366,9.18739 c -1.00457,1.323422 -0.383766,1.9512 0.451018,1.603616 0,0 2.470001,-1.055169 4.025745,-1.102487 1.555745,-0.04732 4.510175,1.135897 4.510175,1.135897 0.668178,0.0975 0.413203,-0.689336 0.183747,-0.985557 -0.231617,-0.772058 -4.164723,-3.763548 -3.858703,-4.827554 0.319215,-1.109882 1.995668,-2.748591 2.555764,-3.975636 0.631063,-0.930795 0.790497,-2.430801 -0.334086,-1.035669 z" id="path24" sodipodi:nodetypes="ccczccscc" inkscape:export-xdpi="47.33268" inkscape:export-ydpi="47.33268"/>
                        <path style="fill:#ff6600;stroke:none;stroke-width:0.264583px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" d="m -27.86285,-36.844053 c -0.02169,0.07049 -2.183642,-1.51605 -1.46998,-2.088042 0.279858,-0.224303 1.166803,0.269716 2.288494,-0.317386 1.121691,-0.587101 2.288496,-1.520093 2.722809,-1.920997 0.139951,-0.129186 -3.541323,4.326425 -3.541323,4.326425 z" id="path26" sodipodi:nodetypes="cszsc" inkscape:export-xdpi="47.33268" inkscape:export-ydpi="47.33268"/>
                        <path inkscape:export-ydpi="47.33268" inkscape:export-xdpi="47.33268" sodipodi:nodetypes="ccczccscc" id="path2317" d="m -23.436196,-41.794272 -7.53366,9.18739 c -1.00457,1.323422 -0.383766,1.9512 0.451018,1.603616 0,0 2.470001,-1.055169 4.025745,-1.102487 1.555745,-0.04732 4.510175,1.135897 4.510175,1.135897 0.668178,0.0975 0.413203,-0.689336 0.183747,-0.985557 -0.231617,-0.772058 -4.164723,-3.763548 -3.858703,-4.827554 0.319215,-1.109882 1.995668,-2.748591 2.555764,-3.975636 0.631063,-0.930795 0.790497,-2.430801 -0.334086,-1.035669 z" style="fill:#ff7200;stroke:none;stroke-width:0.264583px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1;fill-opacity:1"/>
                        <path inkscape:export-ydpi="47.33268" inkscape:export-xdpi="47.33268" sodipodi:nodetypes="cszsc" id="path2319" d="m -27.86285,-36.844053 c -0.02169,0.07049 -2.183642,-1.51605 -1.46998,-2.088042 0.279858,-0.224303 1.166803,0.269716 2.288494,-0.317386 1.121691,-0.587101 2.288496,-1.520093 2.722809,-1.920997 0.139951,-0.129186 -3.541323,4.326425 -3.541323,4.326425 z" style="fill:#ff7d00;stroke:none;stroke-width:0.264583px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1;fill-opacity:1"/>
                    </g>
                </g>
            </svg>
        </button>

        <div class="flex-col flex-item">
            <div class="menu-bar" hidden>
            </div>
            <div class="mln-app-header flex-row">

                <ul class="mln-app-tab flex-row flex-wrap">
                </ul>

                <div class="app-toolbar">
                    <button title="Aviso" id="notification_button" class="notification-button" style="float:right;padding:0;width:28px;height:28px;margin:0 10px;position:relative; cursor:pointer">
                        <div>
                            <i class="fa fa-bell" style="display:block;font-size:150%"></i>
                        </div>
                        <svg id="" style="position: absolute;bottom: 0;right: 0;width: 14px;height: 14px;">
                            <circle cx="7" cy="7" r="7" stroke="black" stroke-width="0" fill="rgb(180, 64, 252)">
                            </circle>
                            <text id="notification_count" x="7" y="11" fill="white" style="font-size: 8pt; width: 6px;" width="20" text-anchor="middle" data-bind="text:\$root.cartQuantity">0</text>
                        </svg>
                    </button>
                    <img id="usr-img" width="28" height="28" style="cursor:pointer; float:right;border-radius:50%">
                </div>

            </div>
        </div>
    </div>

    <div class="notifications top-right" style="z-index:65000"></div>

    <div class="flex-row flex-item" style="height:100%;">
        <div class="side-module-selector" style="display:none">

        </div>

        <div id="content-frame" class="mln-main-frame">
        </div>

        <div id="login-div" class="flex-col" style="flex:1;display:none;cursor:default">

            <div class="flex-item flex-col flex-justify-center" style="max-width:20rem;margin:auto;padding:10px">
                <mln-logo-image style="--logo-text-color:white"></mln-logo-image>
                <div id="login-message" style="font-size:130%;text-align:center;margin-bottom:10px"></div>
                <!-- host -->
                <div class="flex-row flex-align-center form-control mln-host-input" style="display:none;margin-bottom:10px;background: #00000014;padding:7.5px">
                    <span class="input-group-addon fa fa-cloud" style="background:none;border:none;padding:0px 5px 0px 0px;color:white"></span>
                    <input autocomplete="off" class="light-placeholder" id="hostname" type="url" placeholder="Servidor" style="border:none;background:none;color:white">
                </div>
                <div>
                    <select name="" id="licence_type" style="background:#00000014;padding:5px;color:white;width:100%;border-color:silver"></select>
                </div>
                <!-- user -->
                <div class="flex-row flex-align-center form-control" style="margin-top:0.5em;background: #00000014;padding:7.5px">
                    <span class="input-group-addon fa fa-user" style="background:none;border:none;padding:0px 5px 0px 0px;color:white"></span>
                    <input autocomplete="off" class="light-placeholder" id="username" type="text" placeholder="Usuário" style="border:none;background:none;color:white">
                </div>
                <!-- pass -->
                <div class="flex-row flex-align-center form-control" id="pwd-group" style="margin-top:0.5em;background: #00000014;padding:7.5px">
                    <span class="input-group-addon fa fa-key" style="background:none;border:none;padding:0px 5px 0px 0px;color:white"></span>
                </div>
                <div class="flex-row">
                    <button class="btn shadow-around-sml" id="login" style="width:100%;margin-top:1em">ENTRAR</button>
                    <button class="btn shadow-around-sml" id="login_cancel" style="display:none;width:100%;margin-top:1em;margin-left:10px;margin-right:0">CANCELAR</button>
                </div>
            </div>
        </div>
    </div>
</div>`;
// Exports
export default code;